import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PaymentReturnService } from '../services/payment-return.service';

/**
 * Sends the user back to the cart after a card payment.
 *
 * The gateway's return URL is configured server-side and resolves to a path this
 * app doesn't define, so the `**` route rewrites it to the landing page —
 * carrying `session_id` along, which is what identifies the hand-back. Guarding
 * the landing route catches it regardless of which path the gateway aimed at.
 */
export const paymentReturnGuard: CanActivateFn = (route) => {
  if (!route.queryParamMap.has('session_id')) {
    return true;
  }

  const returnPath = inject(PaymentReturnService).consume();
  if (!returnPath) {
    return true;
  }

  // parseUrl (not createUrlTree) so callers can include their own query string.
  return inject(Router).parseUrl(returnPath);
};
